import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FormContainer from "../../../components/atoms/forms/formContainer";
import Search from "../../../components/select/Search";
import Loader from "../../../components/atoms/loader";
import Axios from "../../../AxiosConfig";
import { useStore } from "../../../store";
const CreateAttendance = () => {
    const { layoutStore } = useStore();
    const navigate = useNavigate();
    const [employee, setEmployee] = useState(null);
    const [attendanceDate, setAttendanceDate] = useState(new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split("T")[0]);
    const [inTime, setInTime] = useState(null);
    const [outTime, setOutTime] = useState(null);

    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState(null);

    const [loading, setLoading] = useState(false);
    const [step1Deactivated, setStep1Deactivated] = useState(true);
    const [step2Deactivated, setStep2Deactivated] = useState(true);


    useEffect(() => {
        if (employee && attendanceDate && inTime && outTime) {
            setStep1Deactivated(false);
        } else {
            setStep1Deactivated(true);
        }
        setStep2Deactivated(true);
    }, [employee, attendanceDate, inTime, outTime]);

    const verifyInputs = () => {
        // Check if inTime is before outTime
        setLoading(true);
        setAlertMessage(null);
        if (inTime > outTime) {
            layoutStore.showToaster("In Time Should Be Less Than Out Time", "error")
            setLoading(false);
            return false;
        }
        Axios.post("/working-days/attendance/valid", {
            employee_uuid: employee.uuid,
            date: attendanceDate,
        }).then((res) => {
            setLoading(false);
            let message = res.data.message;
            if (res.data.type === "attendance") {
                setAlertType("red");
            }
            if (res.data.type === "leave") {
                setAlertType("red");
            }
            if (res.data.type === "holiday") {
                setAlertType("yellow");
                setStep2Deactivated(false);
            }
            if (res.data.type === "valid") {
                setAlertType("green");
                setStep2Deactivated(false);
            }
            // Calculate time worked in Hours
            // Conver time object to date object
            const today = new Date();
            let _outTime = new Date(today.toDateString() + ' ' + outTime);
            let _inTime = new Date(today.toDateString() + ' ' + inTime);
            let timeWorked = (_outTime.getTime() - _inTime.getTime()) / 1000;
            message = message + `. Time Worked: ${Math.round(((timeWorked / 60) / 60) * 100) / 100} hours`;
            setAlertMessage(message);
        })
    }

    const createAttendance = () => {
        setLoading(true);
        const today = new Date(attendanceDate);
        let _outTime = new Date(today.toDateString() + ' ' + outTime);
        let _inTime = new Date(today.toDateString() + ' ' + inTime);
        let timeWorked = (_outTime.getTime() - _inTime.getTime()) / 1000;

        let attendanceDateInTime = attendanceDate + ' ' + inTime
        let attendanceDateOutTime = attendanceDate + ' ' + outTime

        // Convert the string to a Date object
        attendanceDateInTime = new Date(attendanceDateInTime);
        attendanceDateOutTime = new Date(attendanceDateOutTime);

        // Use the toLocaleString method to format the date with the local time zone
        attendanceDateInTime = attendanceDateInTime.toLocaleString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false, // Set to true for 12-hour clock, false for 24-hour clock
            timeZoneName: 'longOffset', // This will add the time zone
        });

        attendanceDateOutTime = attendanceDateOutTime.toLocaleString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false, // Set to true for 12-hour clock, false for 24-hour clock
            timeZoneName: 'longOffset', // This will add the time zone
        });

        if (!(
            (attendanceDateInTime.includes("GMT+")) || (attendanceDateInTime.includes("GMT-"))
        )) {
            attendanceDateInTime = attendanceDateInTime + "+00:00"
            attendanceDateOutTime = attendanceDateOutTime + "+00:00"
        }

        Axios.post("/working-days/attendance/create", {
            employee_uuid: employee.uuid,
            date: attendanceDate,
            in_time: attendanceDateInTime,
            out_time: attendanceDateOutTime,
            timeWorked: timeWorked
        }).then((res) => {
            if (res.data.success) {
                setLoading(false);
                layoutStore.showToaster(res.data.success, "success");
                setStep2Deactivated(true);
                navigate('/attendance')
            }
            else {
                setLoading(false);
                layoutStore.showToaster(res.data.error, "error");
            }
        })
    }
    const goBackButton = () => {
        navigate('/attendance')
    }
    
    return (
        <div>
            {loading && <Loader />}
            <button
                type="button"
                onClick={goBackButton}
                className="mb-6 inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Back
            </button>
            <h2 className="text-4xl font-bold tracking-tight text-gray-900">
                Create Attendance
            </h2>
            <div className="mt-4 pt-4 border-t">
                <FormContainer title="Employee" description="Select An Employee To Create Attendance For">
                    <div className="border border-0.5 border-gray-300 hover:border-blue-500 rounded-md">
                        <Search
                            apiURL="/employee/search"
                            setParent={setEmployee}
                        />
                    </div>
                </FormContainer>
                {employee &&
                    <>
                        <FormContainer title="Attendance Details" description="Fill in Details For Marking The Attendance">
                            <div>
                                <label htmlFor="attendanceDate" >
                                    Attendance Date
                                </label>
                                <input
                                    type="date"
                                    name="attendanceDate"
                                    id="attendanceDate"
                                    value={attendanceDate}
                                    max={new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split("T")[0]}
                                    onChange={(e) => {
                                        setAttendanceDate(e.target.value)
                                    }}
                                    className="block w-full border-0.5 border-gray-300 hover:border-blue-500 py-1.5 rounded-md text-gray-900 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                                />
                            </div>
                            <div>
                                <label htmlFor="inTime" >
                                    Clock In Time
                                </label>
                                <input
                                    type="time"
                                    name="inTime"
                                    id="inTime"
                                    onChange={(e) => {
                                        setInTime(e.target.value)
                                    }}
                                    className="block w-full border-0.5 border-gray-300 hover:border-blue-500 py-1.5 rounded-md text-gray-900 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                                />
                            </div>
                            <div>
                                <label htmlFor="outTime" >
                                    Clock Out Time
                                </label>
                                <input
                                    type="time"
                                    name="outTime"
                                    id="outTime"
                                    onChange={(e) => {
                                        setOutTime(e.target.value)
                                    }}
                                    min={inTime}
                                    className="block w-full border-0.5 border-gray-300 hover:border-blue-500 py-1.5 rounded-md text-gray-900 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                                />
                            </div>
                            {alertMessage &&
                                <div className={`border-l-4 border-${alertType}-400 bg-${alertType}-50 p-4`}>
                                    <div className="flex">
                                        <div className="ml-3">
                                            <p className={`text-sm text-${alertType}-700`}>
                                                {alertMessage}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="text-right">
                                <button
                                    type="button"
                                    disabled={step1Deactivated}
                                    onClick={verifyInputs}
                                    className="mt-6 mr-4 items-center rounded border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    Step 1 : Verify Inputs
                                </button>
                                <button
                                    type="button"
                                    disabled={step2Deactivated}
                                    onClick={createAttendance}
                                    className="mt-6 items-center rounded border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    Step 2 : Create Attendance
                                </button>
                            </div>
                        </FormContainer>
                    </>
                }
            </div>
        </div>
    );
}
export default CreateAttendance;